import { render, staticRenderFns } from "./LatihanIlmiah.vue?vue&type=template&id=4b7c8808&scoped=true&"
import script from "./LatihanIlmiah.vue?vue&type=script&lang=js&"
export * from "./LatihanIlmiah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c8808",
  null
  
)

export default component.exports